(function () {
  function initQuoteProducts(root) {
    if (!root || root.dataset.quoteProductsReady === 'true') return;
    root.dataset.quoteProductsReady = 'true';

    var form = root.closest('form') || document.getElementById('QuoteRequestForm');
    var searchInput = root.querySelector('#QuoteProductSearch');
    var resultsEl = root.querySelector('#QuoteProductSearchResults');
    var listEl = root.querySelector('[data-quote-products-list]');
    var emptyEl = root.querySelector('[data-quote-products-empty]');
    var tableEl = root.querySelector('[data-quote-products-table]');
    var rowsEl = root.querySelector('[data-quote-products-rows]');
    var errorEl = root.querySelector('[data-quote-products-error]');
    var payloadEl = root.querySelector('#QuoteProductsPayload');
    var rowTemplate = document.getElementById('QuoteProductRowTemplate');
    if (!form || !searchInput || !resultsEl || !listEl || !payloadEl || !rowTemplate || !rowsEl) return;

    var searchUrl = root.getAttribute('data-search-url') || '/search/suggest';
    var debounceTimer = null;
    var activeIndex = -1;
    var latestController = null;
    var rowId = 0;

    function hideResults() {
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
      activeIndex = -1;
      searchInput.setAttribute('aria-expanded', 'false');
    }

    function showResults(html) {
      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
      searchInput.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    function getResultButtons() {
      return Array.prototype.slice.call(resultsEl.querySelectorAll('[data-add-product]'));
    }

    function setActiveResult(index) {
      var buttons = getResultButtons();
      buttons.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
      });
      activeIndex = index;
      if (index >= 0 && buttons[index]) {
        buttons[index].scrollIntoView({ block: 'nearest' });
      }
    }

    function syncPayload() {
      var rows = rowsEl.querySelectorAll('[data-quote-product-row]');
      var lines = [];
      rows.forEach(function (row, index) {
        var sku = (row.querySelector('[data-field="sku"]') || {}).value || '';
        var titleEl = row.querySelector('[data-field="title"]');
        var title =
          titleEl && titleEl.tagName === 'INPUT'
            ? titleEl.value || ''
            : (titleEl && (titleEl.textContent || titleEl.value)) || '';
        var qty = (row.querySelector('[data-field="qty"]') || {}).value || '1';
        lines.push(
          (index + 1) +
            '. SKU: ' +
            sku.trim() +
            ' | Title: ' +
            String(title).trim() +
            ' | Qty: ' +
            qty
        );
      });
      payloadEl.value = lines.join('\n');
      if (emptyEl) emptyEl.hidden = rows.length > 0;
      if (tableEl) tableEl.hidden = rows.length === 0;
      if (errorEl && rows.length > 0) errorEl.hidden = true;
      payloadEl.setCustomValidity(rows.length ? '' : (errorEl ? errorEl.textContent : 'Add at least one product'));
    }

    function addProduct(product, options) {
      if (!product) return;
      var opts = options || {};
      var qty = Math.max(1, parseInt(opts.qty, 10) || parseInt(product.qty, 10) || 1);
      var silent = !!opts.silent;
      var sku = (product.sku || '').trim();
      var existing = null;
      rowsEl.querySelectorAll('[data-quote-product-row]').forEach(function (row) {
        var rowSku = ((row.querySelector('[data-field="sku"]') || {}).value || '').trim();
        if (sku && rowSku && rowSku.toLowerCase() === sku.toLowerCase()) existing = row;
      });
      if (existing) {
        var qtyInput = existing.querySelector('[data-field="qty"]');
        if (qtyInput) {
          if (opts.replaceQty) {
            qtyInput.value = String(qty);
          } else {
            qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) + qty));
          }
          if (!silent) qtyInput.focus();
        }
        syncPayload();
        if (!silent) {
          hideResults();
          searchInput.value = '';
        }
        return;
      }

      var node = rowTemplate.content.cloneNode(true);
      var row = node.querySelector('[data-quote-product-row]');
      rowId += 1;
      row.dataset.rowId = String(rowId);
      row.querySelector('[data-field="sku"]').value = sku;
      var titleEl = row.querySelector('[data-field="title"]');
      if (titleEl) {
        if (titleEl.tagName === 'INPUT' || titleEl.tagName === 'TEXTAREA') {
          titleEl.value = product.title || '';
        } else {
          titleEl.textContent = product.title || '';
        }
      }
      row.querySelector('[data-field="qty"]').value = String(qty);
      var img = row.querySelector('[data-field="image"]');
      if (img) {
        if (product.image) {
          img.src = product.image;
          img.alt = product.title || '';
          img.classList.remove('eg-quote-products__thumb--empty');
        } else {
          img.removeAttribute('src');
          img.alt = '';
          img.classList.add('eg-quote-products__thumb--empty');
        }
      }
      rowsEl.appendChild(node);
      syncPayload();
      if (!silent) {
        hideResults();
        searchInput.value = '';
        searchInput.focus();
      }
    }

    function productFromButton(btn) {
      return {
        sku: btn.getAttribute('data-sku') || '',
        title: btn.getAttribute('data-title') || '',
        handle: btn.getAttribute('data-handle') || '',
        image: btn.getAttribute('data-image') || '',
      };
    }

    function normalizeImageUrl(value, size) {
      var dimension = size || '600x';
      var raw = '';
      if (!value) return '';
      if (typeof value === 'string') {
        raw = value;
      } else if (value.src) {
        raw = value.src;
      } else if (value.url) {
        raw = value.url;
      }
      if (!raw) return '';
      if (raw.indexOf('//') === 0) raw = 'https:' + raw;

      // Prefer Shopify filename size transform for crisp thumbs.
      var match = raw.match(/\.(jpg|jpeg|gif|png|webp|bmp|tiff|tif)(\?.*)?$/i);
      if (match) {
        var ext = match[0];
        var base = raw.slice(0, raw.length - ext.length);
        base = base.replace(
          /_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*|\d*x\d+)$/i,
          ''
        );
        return base + '_' + dimension + ext;
      }

      try {
        var parsed = new URL(raw, window.location.origin);
        var widthNum = parseInt(String(dimension), 10) || 300;
        parsed.searchParams.set('width', String(widthNum));
        parsed.searchParams.delete('height');
        return parsed.toString();
      } catch (e) {
        return raw;
      }
    }

    function pickProductImage(product) {
      if (!product) return '';
      if (product.featured_image) return product.featured_image;
      if (product.image) return product.image;
      if (product.images && product.images.length) {
        return product.images[0];
      }
      return '';
    }

    function isUnitProduct(product) {
      var title = (product && product.title) || '';
      var handle = (product && product.handle) || '';
      return /\[UNIT\]/i.test(title) || /-unit$/i.test(handle) || /-UNIT$/i.test((product && product.sku) || '');
    }

    function itemsFromProduct(product) {
      var items = [];
      if (!product || isUnitProduct(product)) return items;
      var title = product.title || '';
      var handle = product.handle || '';
      var productImage = normalizeImageUrl(pickProductImage(product), '600x');
      var variants = product.variants && product.variants.length ? product.variants : null;
      if (variants) {
        variants.forEach(function (variant) {
          var sku = ((variant && variant.sku) || product.sku || '').trim();
          if (/-UNIT$/i.test(sku)) return;
          var variantTitle =
            variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
          var displayTitle = title;
          if (variantTitle) displayTitle += ' — ' + variantTitle;
          var image =
            normalizeImageUrl(variant && (variant.featured_image || variant.image), '600x') ||
            productImage;
          items.push({ sku: sku, title: displayTitle, handle: handle, image: image });
        });
      } else {
        items.push({
          sku: (product.sku || '').trim(),
          title: title,
          handle: handle,
          image: productImage,
        });
      }
      return items;
    }

    function renderItems(items) {
      if (!items.length) {
        showResults('<li class="eg-quote-products__result--empty">No products found</li>');
        return;
      }

      var html = items
        .map(function (item) {
          var meta = item.sku ? 'SKU: ' + item.sku : 'No SKU';
          var imageHtml = item.image
            ? '<img class="eg-quote-products__thumb" src="' +
              escapeAttr(item.image) +
              '" alt="" width="56" height="56" loading="lazy" decoding="async">'
            : '<span class="eg-quote-products__thumb eg-quote-products__thumb--empty" aria-hidden="true"></span>';
          return (
            '<li role="option">' +
            '<button type="button" class="eg-quote-products__result" data-add-product' +
            ' data-sku="' +
            escapeAttr(item.sku) +
            '" data-title="' +
            escapeAttr(item.title) +
            '" data-handle="' +
            escapeAttr(item.handle) +
            '" data-image="' +
            escapeAttr(item.image || '') +
            '">' +
            imageHtml +
            '<span class="eg-quote-products__result-copy">' +
            '<span class="eg-quote-products__result-title">' +
            escapeHtml(item.title) +
            '</span>' +
            '<span class="eg-quote-products__result-meta">' +
            escapeHtml(meta) +
            '</span>' +
            '</span>' +
            '</button></li>'
          );
        })
        .join('');

      showResults(html);
    }

    function enrichProductsWithSkus(products, signal) {
      var rootPath = root.getAttribute('data-root') || '/';
      if (rootPath.slice(-1) !== '/') rootPath += '/';

      return Promise.all(
        (products || []).map(function (product) {
          var handle = product && product.handle;
          if (!handle) return Promise.resolve(product);
          return fetch(rootPath + 'products/' + encodeURIComponent(handle) + '.js', {
            method: 'GET',
            headers: { Accept: 'application/json' },
            signal: signal,
          })
            .then(function (res) {
              if (!res.ok) return product;
              return res.json();
            })
            .then(function (full) {
              if (!full) return product;
              return {
                title: full.title || product.title,
                handle: full.handle || product.handle,
                sku: full.sku || product.sku,
                featured_image: full.featured_image || product.featured_image || product.image,
                images: full.images || product.images || [],
                variants: full.variants || product.variants || [],
              };
            })
            .catch(function () {
              return product;
            });
        })
      ).then(function (enriched) {
        var items = [];
        enriched.forEach(function (product) {
          items = items.concat(itemsFromProduct(product));
        });
        return items;
      });
    }

    function renderProducts(products) {
      if (!products || !products.length) {
        showResults('<li class="eg-quote-products__result--empty">No products found</li>');
        return;
      }

      enrichProductsWithSkus(products, latestController ? latestController.signal : undefined)
        .then(function (items) {
          renderItems(items);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          var fallback = [];
          products.forEach(function (product) {
            fallback = fallback.concat(itemsFromProduct(product));
          });
          renderItems(fallback);
        });
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function escapeAttr(value) {
      return escapeHtml(value).replace(/'/g, '&#39;');
    }

    function searchProducts(query) {
      var q = (query || '').trim();
      if (q.length < 2) {
        hideResults();
        return;
      }

      if (latestController) latestController.abort();
      latestController = typeof AbortController !== 'undefined' ? new AbortController() : null;

      showResults('<li class="eg-quote-products__result--status">Searching…</li>');

      var url =
        searchUrl +
        '?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,variants.title,variants.sku,product_type';

      fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        signal: latestController ? latestController.signal : undefined,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Search failed');
          return res.json();
        })
        .then(function (data) {
          var products =
            (data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products) ||
            (data && data.resources && data.resources.products) ||
            [];
          renderProducts(products);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          showResults('<li class="eg-quote-products__result--empty">Unable to search products</li>');
        });
    }

    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        searchProducts(searchInput.value);
      }, 220);
    });

    searchInput.addEventListener('keydown', function (event) {
      var buttons = getResultButtons();
      if (event.key === 'ArrowDown' && buttons.length) {
        event.preventDefault();
        setActiveResult(Math.min(activeIndex + 1, buttons.length - 1));
      } else if (event.key === 'ArrowUp' && buttons.length) {
        event.preventDefault();
        setActiveResult(Math.max(activeIndex - 1, 0));
      } else if (event.key === 'Enter' && activeIndex >= 0 && buttons[activeIndex]) {
        event.preventDefault();
        addProduct(productFromButton(buttons[activeIndex]));
      } else if (event.key === 'Escape') {
        hideResults();
      }
    });

    resultsEl.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-add-product]');
      if (!btn) return;
      addProduct(productFromButton(btn));
    });

    listEl.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('[data-remove-product]');
      if (!removeBtn) return;
      var row = removeBtn.closest('[data-quote-product-row]');
      if (row) row.remove();
      syncPayload();
    });

    listEl.addEventListener('input', function (event) {
      if (event.target && event.target.matches('[data-field]')) syncPayload();
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) hideResults();
    });

    form.addEventListener('submit', function (event) {
      syncPayload();
      var rows = rowsEl.querySelectorAll('[data-quote-product-row]');
      if (!rows.length) {
        event.preventDefault();
        if (errorEl) errorEl.hidden = false;
        searchInput.focus();
        payloadEl.reportValidity();
      }
    });

    function clearPrefillParams() {
      try {
        var url = new URL(window.location.href);
        if (!url.searchParams.has('add') && !url.searchParams.has('variant') && !url.searchParams.has('qty')) {
          return;
        }
        url.searchParams.delete('add');
        url.searchParams.delete('variant');
        url.searchParams.delete('qty');
        var next = url.pathname + (url.search ? url.search : '') + url.hash;
        window.history.replaceState({}, '', next);
      } catch (e) {}
    }

    function prefillFromUrl() {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return;
      }
      var handle = (params.get('add') || params.get('product') || '').trim();
      if (!handle) return;

      var variantId = (params.get('variant') || '').trim();
      var qty = Math.max(1, parseInt(params.get('qty'), 10) || 1);
      var rootPath = root.getAttribute('data-root') || '/';
      if (rootPath.slice(-1) !== '/') rootPath += '/';

      fetch(rootPath + 'products/' + encodeURIComponent(handle) + '.js', {
        method: 'GET',
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Product not found');
          return res.json();
        })
        .then(function (product) {
          if (!product || isUnitProduct(product)) return;
          var items = itemsFromProduct(product);
          if (!items.length) return;

          var match = null;
          if (variantId && product.variants && product.variants.length) {
            var targetId = String(variantId);
            var variant = null;
            for (var i = 0; i < product.variants.length; i++) {
              if (String(product.variants[i].id) === targetId) {
                variant = product.variants[i];
                break;
              }
            }
            if (variant && !/-UNIT$/i.test((variant.sku || '').trim())) {
              var variantTitle =
                variant.title && variant.title !== 'Default Title' ? variant.title : '';
              var displayTitle = product.title || '';
              if (variantTitle) displayTitle += ' — ' + variantTitle;
              match = {
                sku: (variant.sku || product.sku || '').trim(),
                title: displayTitle,
                handle: product.handle || handle,
                image:
                  normalizeImageUrl(variant.featured_image || variant.image, '600x') ||
                  normalizeImageUrl(pickProductImage(product), '600x'),
              };
            }
          }
          if (!match) match = items[0];
          addProduct(match, { qty: qty, silent: true, replaceQty: true });
          clearPrefillParams();
        })
        .catch(function () {
          clearPrefillParams();
        });
    }

    syncPayload();
    prefillFromUrl();
  }

  function boot() {
    document.querySelectorAll('[data-quote-products]').forEach(initQuoteProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-quote-products]');
    if (root) {
      root.dataset.quoteProductsReady = 'false';
      initQuoteProducts(root);
    }
  });
})();
